export const isLoading = (state) => state.loading

export const getSchema = (state) => state.schema

export const getViewEntityType = (state) => state.viewEntityType

export const isDirty = (state) => state.data != null && state.data._dirty === true

export const getData = (state) => state.data

export const getId = (state) => state.id



// WEBPACK FOOTER //
// ./src/store/modules/editor/getters.js